import { useMemo } from 'react';
import { useNavigation } from '../navigation/NavigationProvider';
import { useSdkInitialized } from '../hooks/useSdkInitialized';

const MENU_ITEMS = [
  { label: 'Campaigns', path: '/' },
  { label: 'Profile', path: '/profile' },
  { label: 'Entitlements', path: '/entitlements' },
  { label: 'Settings', path: '/settings' },
] as const;

function resolveBranchName(): string {
  const envBranch =
    process.env.REACT_APP_BRANCH_NAME ||
    process.env.REACT_APP_GIT_BRANCH ||
    process.env.REACT_APP_VERCEL_GIT_COMMIT_REF ||
    process.env.REACT_APP_NETLIFY_BRANCH;

  if (envBranch && envBranch.trim().length > 0) {
    return envBranch.trim();
  }

  if (typeof window !== 'undefined') {
    const fromWindow = (window as unknown as { __BRANCH_NAME__?: string }).__BRANCH_NAME__;
    if (typeof fromWindow === 'string' && fromWindow.trim().length > 0) {
      return fromWindow.trim();
    }
  }

  return 'Nami SDK';
}

const Header = () => {
  const navigation = useNavigation();
  const branchName = useMemo(resolveBranchName, []);
  const sdkInitialized = useSdkInitialized();
  const showHeader = !navigation.path.startsWith('/paywall');

  return (
    <header className="app-header" data-hidden={!showHeader}>
      <button
        className="tv-button"
        style={{ background: 'transparent', borderColor: 'transparent', padding: 0 }}
        onClick={() => navigation.navigate('/')}
        tabIndex={showHeader ? 0 : -1}
      >
        <span className="app-branch">{branchName}</span>
      </button>
      {sdkInitialized && (
        <nav className="app-menu">
          {MENU_ITEMS.map((item) => {
            const isActive = navigation.path === item.path; 
            return (
              <button
                key={item.path}
                type="button"
                className={`app-menu-link tv-button${isActive ? ' active' : ''}`}
                onClick={() => navigation.navigate(item.path)}
                tabIndex={showHeader ? 0 : -1}
              >
                {item.label}
              </button>
            );
          })}
        </nav>
      )}
    </header>
  );
};

export default Header;
